__turbopack_context__.v({
  "canvas": "lTNtiG_canvas",
});
